import React from 'react';
import { translate } from 'react-i18next';

import * as Account from 'accounts/components/form';
import * as Common from 'common/components';

const AccountFormView = ({
  t,
  account,
  accounts,
  company,
  depreciations,
  handleAddCustomField,
  handleRemoveCustomField,
  handleSubmit,
  handleValueChange,
  handleValidation,
  subcompany,
  isFetching,
  handleGroupChange, //Groups
  handleCustomFieldChange, //Groups
  groups, //Groups
  isSaving,
  isSubmitted,
}) => (
  <Common.Wrapper fluid={true}>
    {/* <Common.Header title={t("accounts.accounts_title")} /> */}
    <div className="col-12">
      <Common.Portlet
        title={
          t('menu.configuration') +
          ' > ' +
          t('accounts.accounts_title') +
          ' > ' +
          t(account.id ? 'accounts.edit' : 'accounts.add')
        }
        icon={'archive'}
      >
        <Account.Form
          accounts={accounts}
          company={company}
          depreciations={depreciations}
          handleAddCustomField={handleAddCustomField}
          handleRemoveCustomField={handleRemoveCustomField}
          handleSubmit={handleSubmit}
          handleValidation={handleValidation}
          handleValueChange={handleValueChange}
          isSubmitted={isSubmitted}
          handleGroupChange={handleGroupChange} //Groups
          handleCustomFieldChange={handleCustomFieldChange} //Groups
          groups={groups} //Groups
          isSaving={isSaving}
          subcompany={subcompany}
          values={account}
        />
        <Common.LoaderOverlay show={isFetching} />
      </Common.Portlet>
    </div>
  </Common.Wrapper>
);

export default translate()(AccountFormView);



// WEBPACK FOOTER //
// src/modules/secured/modules/accounts/components/AccountFormView.js